import axios from 'axios';
import React, { useCallback, useState } from 'react';
import AuthField from './components/AuthField';
import AuthForm from './components/AuthForm';
import AuthPageWrapper from './components/AuthPageWrapper';

export default function Register({ navTo, resetConfig, promptId }) {
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordConfirm, setNewPasswordConfirm] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState({ open: false, message: '', severity: 'error' });

  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      setAlert((p) => ({ ...p, open: false }));
      setIsLoading(true);
      resetConfig();
      try {
        const { data } = await axios.post(
          '/register',
          { promptId, newPassword, newPasswordConfirm },
          { validateStatus: () => true }
        );
        if (data.redirect) {
          setAlert({ open: true, message: 'Registration successful.', severity: 'success' });
          navTo('registerSuccess');
        } else {
          setAlert({
            open: true,
            message: data.error || 'Registration failed.',
            severity: 'error',
          });
        }
      } catch {
        setAlert({ open: true, message: 'Server error. Try again later.', severity: 'error' });
      } finally {
        setIsLoading(false);
      }
    },
    [promptId, newPassword, newPasswordConfirm, navTo, resetConfig]
  );

  return (
    <AuthPageWrapper alert={alert} onCloseAlert={() => setAlert((p) => ({ ...p, open: false }))}>
      <AuthForm
        disableSubmit={!newPassword || !newPasswordConfirm}
        isLoading={isLoading}
        onCancel={() => navTo('login')}
        onSubmit={handleSubmit}
        sectionTitle="Registration"
        submitText={isLoading ? 'Processing...' : 'Register'}
      >
        <AuthField
          disabled={isLoading}
          label="New Password"
          onChange={(e) => setNewPassword(e.target.value)}
          type="password"
          value={newPassword}
        />
        <AuthField
          disabled={isLoading}
          label="Confirm New Password"
          onChange={(e) => setNewPasswordConfirm(e.target.value)}
          type="password"
          value={newPasswordConfirm}
        />
      </AuthForm>
    </AuthPageWrapper>
  );
}
